<template>
  <div
    class="sortable-column h-100 d-flex align-center pl-4"
    :class="{ [divClass]: true, 'cursor-pointer': sortable }"
    @click="sortable ? $emit('submitSort', sortId) : null"
  >
    <p>{{ label }}</p>
    <div v-if="tooltip?.html" class="ml-1 d-flex align-center" @click.stop>
      <InsightsTooltip
        :tooltip="tooltip"
        tooltip-direction="end"
      />
    </div>
    <SortArrow
      v-if="sortable"
      :current-sort="sortId"
      :selected-sort="selectedSort"
      :down-arrow-sort-direction="downArrowSortDirection"
      :selected-sort-direction="selectedSortDirection"
    />
  </div>
</template>

<script setup>
import SortArrow from '@/components/shared/SortArrow.vue';
import InsightsTooltip from '@/components/insights/InsightsTooltip.vue';

defineProps({
  label: {
    type: String,
    required: true,
  },
  sortId: {
    type: String,
    required: true,
  },
  selectedSort: {
    type: String,
    required: true,
  },
  selectedSortDirection: {
    type: String,
    required: true,
  },
  downArrowSortDirection: {
    type: String,
    default: 'desc',
  },
  divClass: {
    type: String,
    default: '',
  },
  sortable: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: Object,
    default: () => ({}),
  },
});

defineEmits(['submitSort']);
</script>

<style lang="less" scoped>
.sortable-column p {
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: 150% !important;
}

.sortable-column {
  display: flex;
  align-items: center;
}

.sortable-column:hover :deep(.sort-arrow):not(.active) {
  opacity: .5;
}
</style>
